
import React from 'react'
import { withTranslation } from 'react-i18next'

export default withTranslation()(function PreviewCustomer({ tableProps: data, t }) {
  return (
    <div className="lg:max-w-xl rounded-xl lg:w-full bg-white text-placeholder m-auto px-8 flex flex-col h-fit " style={{ fontSize: '15px', overflow: 'scroll' }}>
      <div className='my-[10px] flex justify-between items-end'>
      </div>
      <div className=' flex flex-col mb-3 '>
        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">{t('transaction.table.CustomElementRegistry')}</label>
          <p className="w-1/2 text-dark-blue capitalize">{data?.full_name}</p>
        </div>
        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">Phone</label>
          <p className="w-1/2 text-dark-blue">{data?.phone}</p>
        </div>
        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">{t('customers.table.email')}</label>
          <p className="w-1/2 text-dark-blue">{data?.email}</p>
        </div>
        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">Total visits</label>
          <p className="w-1/2 text-dark-blue">{data?.total_visits || 0}</p>
        </div>
        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">Items purchased</label>
          <p className="w-1/2 text-dark-blue">{data?.items_purchased || 0}</p>
        </div>
        <div className={`flex flex-col md:flex-row border-b py-3  items-center`}>
          <label className="w-1/2">Average purchased</label>
          <p className="w-1/2 text-dark-blue">{data?.ave_purchase || 0}</p>
        </div>
      </div>
    </div>
  )
})
